import React, { useEffect, useRef, useState } from 'react'
import './styles.scss'
import { Waypoint } from 'react-waypoint'
import { CONFIG } from './config'
import { useWindowSize } from './useWindowSize'

/**
 * Component for Scrollytelling
 *
 * Elements for front layer
 * @prop {React.ReactChild[]} front
 *
 * Function returning background layer element
 * index = current visible front layer element
 * @prop {( index:Number )=> React.ReactChild } background
 *
 * gap between the front layer elements as viewport height
 * @prop { Number } distance
 *
 * space after last front element as viewport height
 * @prop { Number } endSpace
 *
 * @returns { React.Element } React Component
 */

export const Scroller = ({
  front,
  back,
  distance = CONFIG.default.spacerHeight,
  endSpace = CONFIG.default.endSpace,
  className
}: {
  front: { e: React.ReactChild, o: { [key: string]: any } }[]
  back: (e: number, o: { [key: string]: any }) => React.ReactChild
  distance?: number
  endSpace?: number
  className?: string
}) => {
  const windowSize = useWindowSize()
  const [mainHeight, setMainHeight] = useState(0)
  const frontRef = useRef<HTMLDivElement>(null)
  const [currentIndex, setCurrentIndex] = useState(0)

  const [startPos, setStartPos] = useState(0)

  const handleWaypointEnter = (i: number, e: Waypoint.CallbackArgs) => {
    if (e.currentPosition === 'inside' && e.previousPosition === 'below') {
      setCurrentIndex(i)
    }
  }
  const handleWaypointLeave = (i: number, e: Waypoint.CallbackArgs) => {
    if (e.currentPosition === 'below' && e.previousPosition === 'inside') {
      setCurrentIndex(i - 1)
    }
  }
  useEffect(() => {
    if (!frontRef.current) return
    setMainHeight(frontRef.current.clientHeight)
    console.log(frontRef.current.clientHeight, frontRef.current.offsetHeight)
  }, [frontRef.current, windowSize.width, frontRef.current?.clientHeight])



  return (
    <div
      className={'Scroller ' + className}
      style={{
        minHeight: `calc(${mainHeight + 'px'} + ${endSpace}vh)`
      }}
    >
      <div className='back' >{back(currentIndex, front[currentIndex])}</div>
      <div className='front' ref={frontRef}>
        {front.map((element, i) => {

          let d = element.o.distance || distance || 100

          return (
            <React.Fragment key={i}>
              <div className='spacer' style={{ minHeight: d + 'vh' }} />
              <div className='frontel'>
                <Waypoint
                  bottomOffset={20}
                  onEnter={e => handleWaypointEnter(i, e)}
                  onLeave={e => handleWaypointLeave(i, e)}
                >
                  <div className='wrapper'>{element.e}</div>
                </Waypoint>
              </div>

            </React.Fragment >
          )
        })}
      </div>
    </div>
  )
}
